export default {
  en: {
    translation: {
      header_from_register: "Basic Information",
      field_first_name: "First Name",
      field_last_name: "Last Name",
      field_passport: "Passport",
      invalid_passport: "Invalid Passport",
      field_telephone: "Telephone (option)",
      field_email: "Email",
      field_nationality: "Nationality",
      btn_register: "Register Now",
      accept_consent: "Please read the Terms and Conditions of Use and the ",
      accept_consent2: ", then check 'Agree' to continue. ",
      accept_consent_link: "Privacy Policy",

      invalid_email_address: "Invalid Email Address",
      please_screen_capture: "Please Screen Capture",
      login_code: "Login Code",
      thank_for_register: "You're In!",
      thank_for_register2: "Wish You a Lucky Landing",
      go_to_game1: "Claim Your 300 THB",
      go_to_game2: "Shopping Reward",
      go_to_game3: "(Available April 1st, 2024 Onwards)",    
      error_register: "Please enter correctly",
      info_reward_condition : "Save your e-coupon and present it with your passport at Big C checkout to redeem your discounts.",
      info_reward_condition_may : "For a smooth checkout, please download the coupon or access it under 'My Rewards' on our site.  Show it with your passport to get your discount.",

      header_pdp: "Personal Data Protection Policy",
      header_how_to_join: "How to Join",
      new_header_from_register_1 : 'Tourists, Grab Your Chance!',
      new_header_from_register_2 : 'Win a 300 THB Shopping Bonus at Big C',

      header_game_1: "Your Lucky Landing Adventure!",
      header_game_2: "Get Started with a Splash of Luck",
      game_name_1: "Make a 'Lucky Landing' wish and press the button!",
      game_name_2: "",
      btn_Login: "Login",
      text_register: "Register",
      btn_Lobby_play: "Test Your Luck",
      btn_Reward: "My Rewards",
      btn_Close: "Close",
      btn_Start: "START",
      btn_Back: "Back",
      btn_Home: "Home",
      btn_accept_reward: "Accept",
      btn_end_reward: "End",
      win_award: "Congratulations!",
      lose_award: "Your Lose!",
      game_error: "Sorry please try again",
      header_My_Reward: "MY REWARDS",
      detail: "Detail",
      condition: "Condition",

      how_to_play: "How to play",
      biggy_dunk_tank_step_1: "1. Launch & Luck: Smash the red button, watch the ball soar - it's a game of pure chance!",
      biggy_dunk_tank_step_2: "2. Score to Score: Nail the target twice in 3 shots to win. ",

      alert_limit_play: "Limit Quota for playing the game (1/1)",
      alert_limit_play2: "Sorry, you've played the required amount",
      alert_lose : 'Sorry, you did not win.',
      alert_lose2 : 'You can still save with our special coupons!',
      thank_for_play: "Thank you for playing the game",
      can_use_coupon: "You can use the E-Coupon (Exclusive Promotion)",
      to_reward: "Please press 'My reward' ",
      expire_date: "Expire Date"
    },
  },
  cn: {
    translation: {
      header_from_register: "基本信息",
      field_first_name: "名字",
      field_last_name: "性别",
      field_passport: "护照号码",
      invalid_passport: "护照号码无效, 请输入正确电",
      field_telephone: "电话号码（选填)",
      field_email: "电邮地址",
      field_nationality: "国籍",
      btn_register: "完成登记",
      accept_consent: "请细阅条款及细则及 ",
      accept_consent2: "，并点击同意继续。",
      accept_consent_link: "私隐条款",
      invalid_email_address: "电子邮箱地址无效, 请输入正确电子邮箱地址",
      please_screen_capture: "請截圖",
      thank_for_register: "您已成功参与！",
      thank_for_register2: "祝您好运降临。",
      go_to_game1: "领取您的300泰铢",
      go_to_game2: "购物奖励",
      go_to_game3: "(2024年4月1日起可用)",
      error_register: "请输入正确",
      info_reward_condition : "保存您的电子优惠券并在 Big C 结账时与护照一起出示即可兑换折扣。",
      info_reward_condition_may : "结账时请出示您的护照给电子优惠券以享用优惠。",

      header_pdp: "个人数据保护政策",
      header_how_to_join: "如何加入",
      new_header_from_register_1 : '旅客们，把握机会！',
      new_header_from_register_2 : '赢取Big C 300泰铢购物优惠。',
      //go_to_game: "您已成功参与！祝您好运降临。",

      header_game_1: "你的幸运降落冒险",
      header_game_2: "用一抹幸运开始",
      game_name_1: "许下'幸运着陆'的愿望并按下按钮！",
      game_name_2: "",
      login_code: "登入號碼",
      btn_Login: "登入",
      text_register: "登记",
      btn_Lobby_play: "测试您的运气",
      btn_Reward: "我的奖励",
      btn_Close: "关闭",
      btn_Start: "开始",
      btn_Back: "返回",
      btn_Home: "家",
      btn_accept_reward: "接受",
      btn_end_reward: "结束",
      win_award: "恭喜你，成功了!",
      lose_award: "游戏失败!",
      game_error: "抱歉，请重试",
      header_My_Reward: "我的奖励",
      detail: "详情",
      condition: "条件",

      how_to_play: "操作方法",
      biggy_dunk_tank_step_1: "1. 发射并等待：这是一场纯粹的运气游戏！猛击红色按钮，让气球飞翔！",
      biggy_dunk_tank_step_2: "2. 得分即胜利：在三次射击中两次命中目标即可获胜。 ",

      alert_limit_play: "游戏参与次数限制",
      alert_limit_play2: "抱歉，您已经达到所需的游戏次数",
      alert_lose : '抱歉，你没有赢。',
      alert_lose2 : '您仍然可以使用我们的特别优惠券节省费用！',
      thank_for_play: "感谢您玩游戏",
      can_use_coupon: " 您可以使用电子优惠券（独家促销）",
      to_reward: "请点击 '我的奖励' ",
      expire_date: "到期日"

    },
  },
  th: {
    translation: {
      header_from_register: "แบบฟอร์มลงทะเบียน",
      field_first_name: "ชื่อ",
      field_last_name: "นามสกุล",
      field_passport: "passport",
      invalid_passport: "Invalid Passport",
      field_telephone: "เบอร์โทร (option)",
      field_email: "อีเมล",
      field_nationality: "สัญชาติ",
      btn_register: "ลงทะเบียน",
      accept_consent: "Please read the Terms and Conditions of Use and the ",
      accept_consent2: ", then check 'Agree' to continue. ",
      accept_consent_link: "Privacy Policy",
      invalid_email_address: "อีเมลไม่ถูกต้อง",
      thank_for_register: "You're In!Wish You a Lucky Landing",
      go_to_game1: "Claim Your 300 THB",
      go_to_game2: "Shopping Reward",
      go_to_game3: "(Available April 1st, 2024 Onwards)",      
      please_screen_capture: "Please Screen Capture",
      error_register: "Please enter correctly",
      info_reward_condition : "Please present your passport along with the E- Coupon before making payment.",

      header_pdp: "Personal Data Protection Policy",
      header_how_to_join: "How to Join",
      new_header_from_register_1 : 'Tourists, Grab Your Chance!',
      new_header_from_register_2 : 'Win a 300 THB Shopping Bonus at Big C.',

      login_code: "Login Code",
      btn_Login: "เข้าสู่ระบบ",
      text_register: "สมัครสมาชิก",
      btn_Lobby_play: "เล่นเกม",
      btn_Reward: "รางวัลของฉัน",
      btn_Close: "ปิด",
      btn_Start: "เริ่ม",
      btn_Back: "ย้อนกลับ",
      btn_Home: "หน้าหลัก",
      btn_accept_reward: "รับรางวัล",
      btn_end_reward: "จบ",
      win_award: "ยินดีด้วย! คุณได้รางวัล",
      lose_award: "เสียใจด้วย! คุณไม่ได้รางวัล",
      game_error: "ขออภัยระบบขัดข่้อง",
      header_My_Reward: "รางวัลของฉัน",
      detail: "รายละเอียด",
      condition: "เงื่อนไข",

      how_to_play: "วิธีการเล่น",
      biggy_dunk_tank_step_1: "กดปุ่มเพื่อปาลูกบอล",

      alert_limit_play: "ขออภัยคุณเล่นครบตามจำนวนที่กำหนดแล้ว",
      alert_limit_play2: "ขออภัยคุณเล่นครบตามจำนวนที่กำหนดแล้ว",
      thank_for_play: "Thank you for playing the game",
      can_use_coupon: "You can use the E-Coupon (Exclusive Promotion)",
      to_reward: "Please press 'My reward' ",
    },
  },
};
